var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":"https://cdn.botcells.com/Main%20Icon.svg","width":_vm.width,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }